import { MetodoPago } from './metodo-pago';

export class DetallePago {
    public metodoPago: MetodoPago;
    public monto: number;
}



// WEBPACK FOOTER //
// ./src/app/models/detalle-pago.ts